import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    referrer: String,
    fallbackUrl: String
  }

  connect() {
    // Listen for browser back/forward button events
    window.addEventListener('popstate', this.handlePopState.bind(this))
  }

  disconnect() {
    window.removeEventListener('popstate', this.handlePopState.bind(this))
  }

  handlePopState(event) {
    // If we have a referrer that looks like the videos index, navigate there
    if (this.referrerValue && this.isVideosIndexUrl(this.referrerValue)) {
      window.location.href = this.referrerValue
    } else if (this.fallbackUrlValue) {
      // Otherwise use the fallback URL (videos index)
      window.location.href = this.fallbackUrlValue
    } else {
      // Last resort - go to videos index
      window.location.href = '/videos'
    }
  }

  isVideosIndexUrl(url) {
    try {
      const urlObj = new URL(url)
      return urlObj.pathname === '/videos' || urlObj.pathname.startsWith('/videos?')
    } catch {
      return false
    }
  }
}